import React, { FC } from "react";
import {
  genericTouchHandler,
  redirectKeyPressToClick,
} from "../../../../helpers/interactionHandlers";
import { CartIconSvg } from "../../../icons/CartIconSvg";
import { StyledCart, StyledLink, StyledNumOfItems } from "./index.styled";

export interface CartProps {
  onClickHandler?: React.MouseEventHandler;
  numOfItems?: number;
  cartUrl?: string;
}

export const Cart: FC<{ cart: CartProps }> = ({ cart }) => {
  const { onClickHandler, cartUrl, numOfItems } = cart;

  return (
    <StyledCart>
      <StyledLink
        href={cartUrl || "/cart"}
        onClick={onClickHandler}
        onKeyDown={redirectKeyPressToClick}
        onTouchStart={genericTouchHandler}
        tabIndex={0}
      >
        <CartIconSvg />
        <StyledNumOfItems>
          {numOfItems !== undefined && `(${numOfItems})`}
        </StyledNumOfItems>
      </StyledLink>
    </StyledCart>
  );
};
